<template>
	<div class="sidebar-logo-container">
		<transition name="sidebarLogoFade">
			<router-link key="expand" class="sidebar-logo-link" to="/">
				<img v-if="logo" :src="logo" style="border-width: 0px; position: absolute;left: 50px;top: 0px;    opacity: 0.2; width: 1145px;height: 110px;">
				<div class="logo_right">
					<img src="../../../assets/logo/u8.png" style="width: 75px;
    height: 61px;
    margin-top: 23px;
    margin-right: 7px;">
					<div  class="logo_rightwz">
						<span>全国援外培训管理信息系统</span>
						<p>National foreign aid training management information system</p>
					</div>
				</div>
			</router-link>
		</transition>
	</div>
</template>

<script>
	import logoImg from '@/assets/logo/u1.png'

	export default {
		name: 'SidebarLogo',
		data() {
			return {
				title: this.$t('systemName'),
				logo: logoImg
			}
		}
	}
</script>

<style lang="scss" scoped>
	.logo_right {
		width: auto;
		height: 100px;
		float: right;
		margin-right: 80px;
		margin-top: 10px;
	}
    .logo_rightwz{
		float:right;
		line-height:12px;
		margin-top:35px;
		color:white;
		font-weight:bold;
	}
	.logo_rightwz span{
		font-size:30px;
	}
	.logo_rightwz p{
		font-size:12px;
	}
	.sidebarLogoFade-enter-active {
		transition: opacity 1.5s;
	}

	.sidebarLogoFade-enter,
	.sidebarLogoFade-leave-to {
		opacity: 0;
	}

	.sidebar-logo-container {
		position: relative;
		width: 100%;
		height: 118px;
		line-height: 50px;
		background: #1c81d9;
		text-align: center;
		overflow: hidden;

		& .sidebar-logo-link {
			height: 100%;
			width: 100%;

			& .sidebar-logo {
				width: 32px;
				height: 32px;
				vertical-align: middle;
				margin-right: 12px;
			}

			& .sidebar-title {
				display: inline-block;
				margin: 0;
				color: #fff;
				font-weight: 600;
				line-height: 50px;
				font-size: 14px;
				font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
				vertical-align: middle;
			}
		}

		&.collapse {
			.sidebar-logo {
				margin-right: 0px;
			}
		}
	}
</style>
